import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import * as Middleware from "@middlewares/index";
import StoreInterface from "@interface/store/index";

interface IProps {
  favoriteType: string;
  id: number;
  isButtonText: boolean;
  isFavorited: boolean;
}

const FavoritesButton = ({
  favoriteType,
  id,
  isButtonText,
  isFavorited,
}: IProps): ReactElement => {
  const useNetworking = useSelector<StoreInterface, boolean>(
    (state) => state.Profile?.data?.useNetworking
  );

  const handleClick = () => {
    if (!useNetworking) {
      Middleware.Ui.Modal.open("EnterNetworking");
    } else if (isFavorited) {
      Middleware.Favorites.remove(favoriteType, id);
    } else {
      Middleware.Favorites.add(favoriteType, id);
    }
  };

  return (
    <button
      className={`btn ${
        isFavorited
          ? isButtonText
            ? "btn--favorites--added"
            : "btn--favorites-active"
          : isButtonText
          ? "btn--favorites"
          : "btn--favorites-inactive"
      }`}
      onClick={handleClick}
    >
      {isButtonText
        ? isFavorited
          ? "Добавлено в избранное"
          : "Добавить в избранное"
        : ""}
    </button>
  );
};

export default FavoritesButton;
